function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import classNames from '../../_snowpack/pkg/classnames.js';
// @ts-ignore
import { colors, Icon } from './index.js'; // @ts-ignore

import LoadingSpinner from '../modules/loading-spinner.js';
const Button = styled.button.withConfig({
  displayName: "circle-button__Button",
  componentId: "sc-1xsih5w-0"
})(["width:", ";height:", ";background:transparent;border-radius:", ";outline:none;cursor:pointer;position:relative;display:flex;justify-content:center;align-items:center;border:none;&.outline{border:1px solid #dfdfdf;}&:disabled{cursor:default;opacity:0.7;}&.background{background:", ";box-shadow:", ";}&:not(:disabled):focus,&:not(:disabled):hover{background:#fff;box-shadow:0 2px 4px rgba(0,0,0,0.1);span{opacity:1;&.right{transform:translateY(-50%) translateX(0%);}&.left{transform:translateY(-50%) translateX(0%);}&.top{transform:translateY(-100%) translateX(0%);}&.bottom{transform:translateY(20%) translateX(0%);}}}&:not(:disabled):active{transform:scale(0.9);}span{position:absolute;top:50%;width:300%;pointer-events:none;transition:all 0.2s ease-in-out;opacity:0;font-weight:600;font-size:12px;color:", ";&.right{left:110%;top:50%;text-align:left;transform:translateY(-100%) translateX(0%);}&.left{right:110%;text-align:right;transform:translateY(-100%) translateX(0%);}&.top{top:-10%;text-align:center;transform:translateY(-50%) translateX(0%);}&.bottom{top:110%;text-align:center;transform:translateY(0%) translateX(0%);}}"], p => typeof p.$size === 'string' ? `${p.$size}` : `${p.$size}px`, p => typeof p.$size === 'string' ? `${p.$size}` : `${p.$size}px`, p => `${p.$borderRadius}%`, p => p.$background, p => p.$background === 'transparent' ? '0 2px 4px rgba(0, 0, 0, 0.0)' : '0 2px 4px rgba(0, 0, 0, 0.1);', colors.frostbite);
export function CircleButton(props) {
  const {
    action,
    background = 'transparent',
    borderRadius = 50,
    children,
    icon = /*#__PURE__*/React.createElement(Icon.BackArrow1, null),
    loading = false,
    outline = false,
    size = 45,
    text = 'Back',
    textDirection = 'right',
    type = 'button',
    ...rest
  } = props;

  const onButtonClick = event => {
    event.stopPropagation(); // chrome hack
    // this is to lose the focus, because the button has showing the label after being clicked

    event.currentTarget.blur();
    action === null || action === void 0 ? void 0 : action(event);
  };

  return /*#__PURE__*/React.createElement(Button, _extends({
    $background: background,
    $borderRadius: borderRadius,
    $size: size,
    className: classNames({
      background,
      outline
    }),
    onClick: onButtonClick,
    type: type
  }, rest), loading ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: 20,
    strokeSize: '2'
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, children, icon, /*#__PURE__*/React.createElement("span", {
    className: textDirection
  }, text)));
}